const guiColors = {
    'motion-primary': '#ff71ce',
    'motion-primary-transparent': '#ff71cee6',
    'motion-tertiary': '#d94fae',

    'looks-secondary': '#ff71ce',
    'looks-transparent': '#ff71ce59',
    'looks-light-transparent': '#ff71ce26',
    'looks-secondary-dark': 'hsla(320, 100%, 62%, 1)',

    'extensions-primary': 'hsla(271, 100%, 70%, 1)',
    'extensions-tertiary': 'hsla(193, 99%, 50%, 1)',
    'extensions-transparent': 'hsla(271, 100%, 70%, 0.35)',
    'extensions-light': 'hsla(193, 99%, 85%, 1)',

    'drop-highlight': '#01cdfe',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'rgba(255, 113, 206, 0.75) 0%, ' +
        'rgba(185, 103, 255, 0.75) 35%, ' +
        'rgba(1, 205, 254, 0.75) 70%, ' +
        'rgba(5, 255, 161, 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: '#ff71ce',
    checkboxActiveBorder: '#01cdfe'
};

export {
    guiColors,
    blockColors
};
